export default class ProposalItemPriceAfterAdjustmentCalculationError extends Error {
    
}